import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { ILocale } from "infrastructure/localization";
import { INotification } from "infrastructure/notification";
import { actionProcessing } from "infrastructure/store";
import { getScreenExtraReducers } from "ui/app";
import { IPickerSearchCriterion } from "ui/shared/helpers/plex-components";
import { IIndustry } from "ui/shared/models/common";

import { ITranslationHistoryState, ITranslationHistoryItem, ITranslationHistoryFilterData, getInitialTranslationHistoryState } from "./TranslationHistory.state";

const initialState = getInitialTranslationHistoryState();

export const translationHistory = createSlice({
  name: "translationHistory",
  initialState: initialState,
  reducers: {
    initTranslationHistory: actionProcessing.createWithClearNotification((state: ITranslationHistoryState, action: PayloadAction<string>) => {
      return {
        ...state,
        termId: action.payload,
        filter: {
          locales: [],
          industries: [],
          data: { pinned: false }
        }
      };
    }),
    applyTranslationHistoryFilter: (state: ITranslationHistoryState, action: PayloadAction<ITranslationHistoryFilterData>) => {
      return {
        ...state,
        filter: { ...state.filter, data: action.payload }
      };
    },
    loadTranslationHistory: actionProcessing.createWithClearNotification((state: ITranslationHistoryState) => {
      return {
        ...state,
        isLoading: true
      };
    }),
    loadTranslationHistoryCompleted: (state: ITranslationHistoryState, action: PayloadAction<ITranslationHistoryItem[]>) => {
      return {
        ...state,
        isLoading: false,
        data: action.payload
      };
    },
    loadTranslationHistoryError: (state: ITranslationHistoryState, action: PayloadAction<INotification>) => {
      return {
        ...state,
        notifications: [...state.notifications, action.payload],
        isLoading: false
      };
    },
    loadLocales: (state, _: PayloadAction<IPickerSearchCriterion<ILocale>>) => {
      return {
        ...state,
        isLoading: true
      };
    },
    loadLocalesCompleted: (state, action: PayloadAction<ILocale[]>) => {
      return {
        ...state,
        isLoading: false,
        filter: { ...state.filter, locales: action.payload }
      };
    },
    loadIndustries: (state, _: PayloadAction<IPickerSearchCriterion<IIndustry>>) => {
      return { ...state, isLoading: true };
    },
    loadIndustriesCompleted: (state, action: PayloadAction<IIndustry[]>) => {
      return { ...state, isLoading: false, filter: { ...state.filter, industries: action.payload } };
    },
    clearState: actionProcessing.createWithClearNotification(() => {
      return {
        ...initialState
      };
    })
  },
  extraReducers: getScreenExtraReducers<ITranslationHistoryState>("notifications", initialState)
});
